module.exports = __webpack_public_path__ + "img/message.8894d482.png";